// extracted by mini-css-extract-plugin
export default {"overlay":"gy-z","bodyOpen":"hy-z","content":"iy-z","header":"jy-z","close":"ky-z","closeNoHeading":"ly-z"};